import { useEffect, useRef, useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { useShowAlert } from "../../context/AlertContext";
import AxiosInstance from "../../utils/AxiosInstance";
import handleError from "../../constants/handleError";
import RemarkModal from "../../components/pages/sale/Remark";
import uRLs from "../../utils/baseUtils";
import PayLaterButton from "../../components/pages/sale/PaylaterBtn";
import CashButton from "../../components/pages/sale/cashbtn";
import ReturnSale from "../ReturnSale";
import { capitalizeFirstLetter, parseAmount } from "./invoiceUtils";
import SaleSettings from "../SaleSettings";
import { EditIcon, NotepadIcon, ShowIcon } from "../../constants/Icons";
import { usePermission } from "../../context/PermissionContext";

const InvoiceInfoSidebar = ({
  globalData,
  optData,
  isPurchase,
  returnTrack,
  handleSelectedSale,
  handlelatestSale,
  closeAuto,
  setCloseAuto,
  latestVersion,
  setData,
  returnTrackId,
  handleSelectedReturnSale,
  invoiceConfig,
}) => {
 
  const { isPreSale, documentConfig } = invoiceConfig;  
  const [showFullRemark, setShowFullRemark] = useState(false);
  const paylaterRef = useRef();
  const cashRef = useRef();
  const [remark, setRemark] = useState("");
  const [remarkModalOpen, setRemarkModalOpen] = useState(false);
  const showAlert = useShowAlert();
  const {viewOption} = usePermission();
  const handleUpdateRemark = async (value) => {
    try {
      let data;
      if (isPreSale) {
        const response = await AxiosInstance.patch(
          `module/presale/remarks/${globalData?.preSaleData?._id}`,
          {
            remarks: value,
          },
        );

        data = response.data;

        setRemark(data?.results?.remarks || value);

        setData((prev) => ({
          ...prev,
          preSaleData: {
            ...prev.preSaleData,
            remarks: data?.results?.remarks || value,
          },
        }));
      } else {
        const response = await AxiosInstance.put(
          `module/sale/remark/${returnTrack ? globalData?._id : globalData?._id}`,
          {
            remark: value,
          },
        );

        data = response.data;

        setRemark(data?.results?.remark || value);

        setData((prev) => ({
          ...prev,
          remark: data?.results?.remark || value,
        }));
      }

      setRemarkModalOpen(false);
    } catch (err) {
      handleError(err, showAlert);
      console.error(err);
    }
  };

  const remarkText = remark;
  useEffect(() => {
    setRemark(documentConfig?.remarks);
  }, [documentConfig?.remarks]);
  const isReturnRemark = !!documentConfig?.remarks;
  const isReturnSale = !!returnTrack;
  const showRemarkSection = !isReturnSale || isReturnRemark;

  return (
    <div
      className="border-start bg-white"
      style={{
        width: "300px",
        flex: "0 0 300px",
        overflowY: "auto",
        padding: "8px",
      }}
    >
      {/* REMARK SECTION */}
      {showRemarkSection && (
        <div
          className="mb-2"
          style={{
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: "10px",
            padding: "10px",
          }}
        >
          <div
            className="d-flex align-items-center mb-1"
            style={{
              color: "#16a34a",
              fontWeight: "600",
              fontSize: "13px",
            }}
          >
            <NotepadIcon iClass="me-1 font-16"/>
            Remark
            {!returnTrack && !isPurchase && (
              <div className="ms-auto">
                <button
                  type="button"
                  className="btn-label-primary rounded shadow-none border-0 cursor-pointer"
                  onClick={() => {
                    setRemark(remarkText || "");
                    setRemarkModalOpen(true);
                  }}
                >
                   <EditIcon />
                </button>
              </div>
            )}
          </div>
          <div
            style={{
              color: "#4b5563",
              fontSize: "12px",
              lineHeight: "1.6",
              wordBreak: "break-word",
              ...(showFullRemark
                ? {}
                : {
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }),
            }}
          >
            {" "}
            {capitalizeFirstLetter(remarkText)}{" "}
          </div>{" "}
          {remarkText?.length > 120 && (
            <span
              onClick={() => setShowFullRemark(!showFullRemark)}
              style={{
                color: "#2563eb",
                fontSize: "12px",
                cursor: "pointer",
                fontWeight: "500",
              }}
            >
              {" "}
              {showFullRemark ? "Show Less" : "...more"}{" "}
            </span>
          )}{" "}
        </div>
      )}
         
      {viewOption("saleSettings", "isOverallDiscount") && 
      // parseAmount(documentConfig?.overallDiscount) > 0 &&
      !isPurchase &&
        !globalData?.returnSaleData && (
          <div
            className="mb-2  d-flex align-items-center justify-content-between"
            style={{
              background: "#fff",
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              padding: "10px",
            }}
          >
            <div>
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#64748b",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                Overall Discount
              </div>
            </div>

            <div className="font-14">
              <strong>{documentConfig?.overallDiscount}</strong>
            </div>
          </div>
        )}

      {
      // !isPurchase &&
        !isPreSale &&
        (returnTrack ? (
          <>
            <div
              style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              {/* HEADER */}
              <div
                className="d-flex align-items-center justify-content-between"
                style={{
                  padding: "8px 12px",
                  borderBottom: "1px solid #f1f5f9",
                  background: "#f9fafb",
                }}
              >
                <div
                  className="fw-600"
                  style={{
                    fontSize: "13px",
                    color: "#111827",
                  }}
                >
                  {returnTrack ? "Refund Details" : "Payment Details"}
                </div>
              </div>

              {/* PAYMENT LIST */}
              <div>
                {/* CASH */}
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    padding: "4px 8px",
                    borderBottom: "1px solid #f3f4f6",
                    cursor:
                      parseAmount(documentConfig?.cashPaid) > 0
                        ? "pointer"
                        : "default",
                  }}
                  // onClick={(e) => {
                  //   if (paymentData?.CASH > 0) {
                  //     cashRef.current.openPopover(e);
                  //   }
                  // }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#f9fafb";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#fff";
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <span className="font-13">Cash</span>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <span className="fw-600 font-13">
                      {documentConfig?.cashPaid}
                    </span>
                  </div>
                </div>

                {/* CARD */}
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    padding: "4px 8px",
                    borderBottom: "1px solid #f3f4f6",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#f9fafb";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#fff";
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <span className="font-13">Card</span>
                  </div>

                  <span className="fw-600 font-13">
                    {documentConfig?.cardPaid}
                  </span>
                </div>

                {/* ONLINE */}
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    padding: "4px 8px",
                    borderBottom: "1px solid #f3f4f6",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#f9fafb";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#fff";
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <span className="font-13">Online</span>
                  </div>

                  <span className="fw-600 font-13">
                    {documentConfig?.onlinePaid}
                  </span>
                </div>

                {/* UPI */}
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    padding: "4px 8px",
                    borderBottom: "1px solid #f3f4f6",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#f9fafb";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#fff";
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <span className="font-13">UPI</span>
                  </div>

                  <span className="fw-600 font-13">
                    {" "}
                    {documentConfig?.upiPaid}
                  </span>
                </div>

                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    padding: "4px 8px",
                    cursor:
                      parseAmount(documentConfig?.balanceDue) > 0
                        ? "pointer"
                        : "default",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#f9fafb";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#fff";
                  }}
                  // onClick={(e) => {
                  //   if (paymentData?.PAYLATER > 0) {
                  //     paylaterRef.current.openPopover(e);
                  //   }
                  // }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <span className="font-13">PayLater</span>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <span className="fw-600 font-13 text-danger">
                      {documentConfig?.balanceDue}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div
              style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <div
                className="d-flex align-items-center justify-content-between"
                style={{
                  padding: "8px 12px",
                  borderBottom: "1px solid #f1f5f9",
                  background: "#f9fafb",
                }}
              >
                <div
                  className="fw-600"
                  style={{
                    fontSize: "13px",
                    color: "#111827",
                  }}
                >
                  {returnTrack ? "Refund Details" : "Payment Details"}
                </div>
              </div>

              {/* PAYMENT LIST */}
              <div>
                {/* CASH */}
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    padding: "4px 8px",
                    borderBottom: "1px solid #f3f4f6",
                    cursor:
                      parseAmount(documentConfig?.cashPaid) > 0
                        ? "pointer"
                        : "default",
                  }}
                  onClick={(e) => {
                    if (parseAmount(documentConfig?.cashPaid) > 0) {
                      cashRef.current.openPopover(e);
                    }
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#f9fafb";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#fff";
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    {/* <i className="bx bx-money font-18 text-success"></i> */}
                    {parseAmount(documentConfig?.cashPaid) > 0 && (
                      <ShowIcon iClass="text-success  font-16"/>
                    )}
                    <span className="font-13">Cash</span>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <span className="fw-600 font-13">
                      {documentConfig?.cashPaid || 0}
                    </span>
                  </div>
                </div>

                {/* CARD */}
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    padding: "4px 8px",
                    borderBottom: "1px solid #f3f4f6",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#f9fafb";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#fff";
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <span className="font-13">Card</span>
                  </div>

                  <span className="fw-600 font-13">
                    {documentConfig?.cardPaid || 0}
                  </span>
                </div>

                {/* ONLINE */}
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    padding: "4px 8px",
                    borderBottom: "1px solid #f3f4f6",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#f9fafb";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#fff";
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <span className="font-13">Online</span>
                  </div>

                  <span className="fw-600 font-13">
                    {documentConfig?.onlinePaid || 0}
                  </span>
                </div>

                {/* UPI */}
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    padding: "4px 8px",
                    borderBottom: "1px solid #f3f4f6",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#f9fafb";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#fff";
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <span className="font-13">UPI</span>
                  </div>

                  <span className="fw-600 font-13">
                    {documentConfig?.upiPaid}
                  </span>
                </div>

                {/* PAYLATER */}
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    padding: "4px 8px",
                    cursor:
                      Math.abs(parseAmount(documentConfig?.balanceDue)) > 0
                        ? "pointer"
                        : "default",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#f9fafb";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#fff";
                  }}
                  onClick={(e) => {
                    if (Math.abs(parseAmount(documentConfig?.balanceDue)) > 0) {
                      paylaterRef.current.openPopover(e);
                    }
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    {/* <i className="bx bx-time font-18 text-danger"></i> */}
                    {Math.abs(parseAmount(documentConfig?.balanceDue)) > 0 && (
                       <ShowIcon iClass="text-danger  font-16"/>
                    )}
                    <span className="font-13">PayLater</span>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <span className="fw-600 font-13 text-danger">
                      {documentConfig?.balanceDue || 0}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </>
        ))}
      <RemarkModal
        open={remarkModalOpen}
        initialValue={remark}
        onClose={() => setRemarkModalOpen(false)}
        onSave={handleUpdateRemark}
      />

      {!returnTrack && !isPurchase && !isPreSale && (
        <SaleSettings
          isData={globalData}
          DateConverter={DateConverter}
          CurrencyConverter={CurrencyConverter}
          handleSelectedSale={handleSelectedSale}
          version={globalData?.saleVersion}
          handlelatestSale={handlelatestSale}
          closeAuto={closeAuto}
          setCloseAuto={setCloseAuto}
          latestVersion={latestVersion}
        />
      )}
      {uRLs.RETURN_SALE === "true" && !isPurchase && !isPreSale && (
        <ReturnSale
          saleID={returnTrack ? returnTrackId : globalData?._id}
         saleReturnNo={
            returnTrack
              ? invoiceConfig?.documentConfig?.number
              : globalData?.returnSaleData?.saleReturnNo
          }
          handleSelectedReturnSale={handleSelectedReturnSale}
          version={globalData?.saleVersion}
          handlelatestSale={handlelatestSale}
          closeAuto={closeAuto}
          setCloseAuto={setCloseAuto}
          latestVersion={latestVersion}
        />
      )}
      <CashButton
        ref={cashRef}
        trackId={
          returnTrack
            ? globalData?.boxCashInfo?.trackid
            : globalData?.boxCashInfo?.trackid
        }
        trackMode={
          returnTrack
            ? globalData?.boxCashInfo?.trackmode
            : globalData?.boxCashInfo?.trackmode
        }
      />

      <PayLaterButton
        ref={paylaterRef}
        trackId={globalData?.paylaterInfo?.trackid}
        customerId={globalData?.paylaterInfo?.customerid}
        trackMode={globalData?.paylaterInfo?.trackmode}
      />
    </div>
  );
};

export default InvoiceInfoSidebar;
